import { isPlatformServer } from '@angular/common';
import { EnvironmentProviders, InjectionToken, PLATFORM_ID, REQUEST_CONTEXT, inject, makeEnvironmentProviders } from '@angular/core';
import { ROUTES, Route, RouterFeatures, provideRouter, withPreloading, withRouterConfig } from '@angular/router';

import { SpeculativeLinkPreloader } from '@frontend/vanilla/features/speculative-link';

export const REQUEST_EXPLORATION = new InjectionToken<boolean>('REQUEST_EXPLORATION', {
    providedIn: 'root',
    // eslint-disable-next-line  eqeqeq
    factory: () => isPlatformServer(inject(PLATFORM_ID)) && inject(REQUEST_CONTEXT) === null,
});

// TODO Write Docs for why this is necessary @Chris
function provideContextAwareRoutes(routes: Route[]) {
    const routeExplorationRoutes: Route[] = [{ path: '**', children: [] }];
    return makeEnvironmentProviders([
        {
            provide: ROUTES,
            useFactory: () => (inject(REQUEST_EXPLORATION) ? routeExplorationRoutes : routes),
            multi: true,
        },
    ]);
}

export function provideHostRouter(routes: Route[]): EnvironmentProviders[] {
    const features: RouterFeatures[] = [
        withPreloading(SpeculativeLinkPreloader),
        withRouterConfig({ urlUpdateStrategy: 'eager' }),
        // disabled for now to investigate myaccount issues
        // withViewTransitions({ skipInitialTransition: true }),
    ];

    return [provideRouter([], ...features), provideContextAwareRoutes(routes)];
}
